export default {
    rightsReserved: 'Todos os direitos reservados',
    generalConditionsLink: '/condicoes-gerais',
    generalConditions: 'Condições Gerais',
    frequentQuestionsLink: '/ajuda',
    frequentQuestions: 'Perguntas Frequentes',
    regretButton: 'Direito de arrependimento',
    regretButtonLink: 'https://p10-cdn.s3.amazonaws.com/p10botondearrepentimiento.pdf',
}